import { useSelector } from 'react-redux';
import type { RootState } from '~/redux/store.ts';
import { BuyerOrderView } from '~/pages/order-view/sections/BuyerOrderView';
import { SellerOrderView } from '~/pages/order-view/sections/SellerOrderView';
import { useNavigate, useParams } from 'react-router';

export function OrderView() {
  const role = useSelector((state: RootState) => state.auth.user?.role);
  const { orderId } = useParams();
  const navigate = useNavigate();

  if (!orderId) {
    navigate('/orders/all-orders');
    return;
  }

  if (role === 'BUYER') {
    return <BuyerOrderView orderId={orderId} />;
  } else {
    return <SellerOrderView orderId={orderId} />;
  }
}
